import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import './index.css';
import App from './App';
import store, { history } from './store'
import registerServiceWorker from './registerServiceWorker';
import { ConnectedRouter } from 'react-router-redux'
import { firebaseAuthStart } from "./data/auth"

// TODO: should go in the data component
firebaseAuthStart(store);

const target = document.getElementById('root')

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App/>
    </ConnectedRouter>
  </Provider>,
  target
)

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js